var _circle, _g, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3105_1999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 31,
    height: 31
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9995,
    cy: 15.0001,
    r: 14.9138,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.172414
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3105_1999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29213 26.2071C6.29213 21.3984 10.1904 17.5002 14.9991 17.5002C19.8078 17.5002 23.706 21.3984 23.706 26.2071V28.7933C23.706 33.602 19.8078 37.5002 14.9991 37.5002C10.1904 37.5002 6.29213 33.602 6.29213 28.7933V26.2071Z",
    stroke: "#404040",
    strokeWidth: 0.517243
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9996,
    cy: 15.0001,
    r: 14.7414,
    stroke: "#404040",
    strokeWidth: 0.517243
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0855,
    cy: 11.9828,
    r: 5.17243,
    stroke: "#404040",
    strokeWidth: 0.517243
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.5c0577f6b73f5c18cab2e704624099f3.svg";
export { ForwardRef as ReactComponent };